export const ADMINISTRATOR_CONFIGURATION_EMAIL_RATE_LIMITER_ID = 1
